<template>
<v-card outlined elevation="0" tile>
    <v-card-text class="d-flex justify-space-between align-end">
        <Summary :params="params" :context="context"/>
        <v-card v-if="list.length" @click="exportToExcel" class="pa-2 text-center" outlined>
            <div><v-icon small>mdi-file-export-outline</v-icon></div>
            EXPORTAR A EXCEL
        </v-card>
    </v-card-text>
    <v-divider/>
    <v-data-table
        :headers="headers"
        :items="list"
        :items-per-page="-1"
        :loading="fetching"
        hide-default-footer
        disable-pagination
        disable-filtering
        >
        <!-- eslint-disable-next-line -->
        <template v-slot:item.juego="{ item }">
            <v-card outlined class="pa-1">
                <div class="line-height-1 text-overline">{{ item.juego }}</div>
                <div class="line-height-1 text-caption text-uppercase">{{ item.divisa }}</div>
            </v-card>
        </template>
        <!-- eslint-disable-next-line -->
        <template v-slot:item.venta="{ item }">
            <Venta :reporte="item"/>
        </template>
        <!-- eslint-disable-next-line -->
        <template v-slot:item.comision="{ item }">
            <Comision :reporte="item"/>
        </template>
        <!-- eslint-disable-next-line -->
        <template v-slot:item.premio="{ item }">
            <Premio :reporte="item"/>
        </template>
        <!-- eslint-disable-next-line -->
        <template v-slot:item.total="{ item }">
            <Total :reporte="item"/>
        </template>
        <!-- eslint-disable-next-line -->
        <template v-slot:item.banqueo="{ item }">
            <Banqueo :reporte="item"/>
        </template>
    </v-data-table>
</v-card>
</template>
<script>
import * as excelJS from 'exceljs';
import { saveAs } from "file-saver";

import ReportePorJuegoService from '@/services/reporte/ventas/ReportePorJuegoService';

import Summary from '@/components/entities/reporte/venta/divisa/summary.vue';

import Venta from '@/components/entities/reporte/components/venta.vue';
import Comision from '@/components/entities/reporte/components/comision.vue';
import Premio from '@/components/entities/reporte/components/premio.vue';
import Total from '@/components/entities/reporte/components/total.vue';
import Banqueo from '@/components/entities/reporte/components/banqueo.vue';

export default {
    components: {
        Summary,
        Venta,
        Comision,
        Premio,
        Total,
        Banqueo,
    },
    props: {
        params: {
            defaults: function() {
                return {};
            },
        },
        context: {
            default: 'comercio',
        },
    },
    data: function() { 
        return {
            list: [],
            fetching: false,
            expanded: [],
        }
    },
    computed: {
        headers: function () {
            return [
                { text: 'Juego', align: 'start', value: 'juego' },
                { text: 'Ventas', value: 'venta' },
                { text: 'Comisión', value: 'comision' },
                { text: 'Premios', value: 'premio' },
                { text: 'Total', value: 'total'},
                { text: 'Banqueo', value: 'banqueo', align: 'center' },
            ];
        },
        user: function () {
            return this.$store.getters['persist/auth/user'];
        },
    },
    methods: {
        fetch: async function () {
            this.fetching = true;
            this.list = [];
            this.expanded = [];

            const comercio = [];
            if (this.user.comercio_type !== 'operadora') comercio[this.getComType(this.user.comercio_type)] = this.user.comercio_id;

            const params = { ... this.params, ...comercio };

            if (this.context == 'sistema') {
                params['group_by'] = 'sistema';
                params['comercio_type'] = 'sistema';
            }

            try {
                const {
                    reportList
                } = await ReportePorJuegoService.getConsolidado(params);

                this.list = reportList;
            } catch (error) {
                console.log(error);
            }

            this.fetching = false;
        },
        getComType: function (comercioType) {
            return {'master': 'master_id', 'comercializadora': 'comercializadora_id', 'grupo': 'grupo_id', 'taquilla': 'taquilla_id'}[comercioType];
        },
        exportToExcel () {
            if (this.list.length == 0) return;
            const workbook = new excelJS.Workbook();
            workbook.creator = '';
            workbook.lastModifiedBy = 'System';
            workbook.created = new Date();
            let sheet = workbook.addWorksheet("Reporte");

            sheet.getRow(1).values = [
                'Juego', 
                'Divisa',
                'Ventas '+ this.divisa.code, 
                'Comision '+ this.divisa.code, 
                'Premios '+ this.divisa.code, 
                'Total '+ this.divisa.code, 
                'BanqueoA',
                'BanqueoB',
            ];
            
            let records = [];
            this.list.forEach(reporte => {
                records.push([
                    reporte.juego,
                    reporte.divisa,
                    parseFloat(reporte.venta.toFixed(2)),
                    parseFloat(reporte.comision.toFixed(2)),
                    parseFloat(reporte.premio.toFixed(2)), 
                    parseFloat(reporte.total.toFixed(2)), 
                    parseFloat(reporte.banqueo[0].toFixed(2)),
                    parseFloat(reporte.banqueo[1].toFixed(2))  
                ]);
            });
            sheet.addRows(records);
            
            sheet.getColumn(1).alignment = {
                vertical: "middle",
                horizontal: "center",
            };
            sheet.getRow(1).font  = {
                bold: true
            };
            sheet.columns.forEach(column => {
                const lengths = column.values.map(v => v.toString().length);
                const maxLength = Math.max(...lengths.filter(v => typeof v === 'number'));
                column.width = maxLength + 2;
            });

            const tittle = 'Reporte de Ventas por Divisa desde '
                + this.params.daterange[0].split("-").reverse().join("-")
                + ' hasta '
                + this.params.daterange[1].split("-").reverse().join("-");

            sheet.insertRow(1, [tittle]);
            sheet.mergeCells("A1:H1");

            sheet.getCell('A1').fill = {
                type: 'pattern',
                pattern:'solid',
                fgColor:{argb:'c9daf8'}
            };
            
            const rmax = this.list.length + 2;
            sheet.addConditionalFormatting({
                ref: 'A2:H' + rmax,
                rules: [
                    {
                    type: 'expression',
                    formulae: ['MOD(ROW(),2)=0'],
                    style: {fill: {type: 'pattern', pattern: 'solid', bgColor: {argb: 'cccccc'}}},
                    }
                ]
            });

            const filename = 'Reporte Divisa ' + this.$luxon.now().toFormat('MM-dd HHmmss') + '.xlsx';
            workbook.xlsx.writeBuffer().then(function(buffer) {
                const blob = new Blob([buffer], { type: "applicationi/xlsx" });
                saveAs(blob, filename);
            });
        }
    },
    watch: {
        params: function () {
            this.fetch();
        },
        'fetching': function (fetching) {
            this.$emit('update:loading', fetching);
        }
    }
}
</script>